// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "-" + {"148":"bfec4e6ab4b089d5b17d","298":"e452f1698295942c4a04","767":"bfec4e6ab4b089d5b17d"}[chunkId] + ".css";
};